<template>
    <div style="box-sizing: border-box;padding: 20px 0;">
        <div class="bk">
            <div class="flx alc cursor" style="height: 100%;" @click="bobk">
                <i class="el-icon-arrow-left" style="margin-right: 8px;"></i> 返回
            </div>
        </div>
        <div class="fs">
            <div class="flx jsb" style="box-sizing: border-box;padding: 30px;">
                <div class="flx alc">
                    <div class="demo-input-suffix">
                        <div class="deword">属性方式：</div>
                        <el-input placeholder="请输入姓名、手机、邮箱" v-model="values" type="text"></el-input>
                    </div>
                    <div class="demo-input-suffix">
                        <div class="deword">
                            审核状态：
                        </div>
                        <el-select v-model="value" placeholder="请选择">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="checkBtn" @click="searchThis">
                        查询
                    </div>
                </div>
                <div class="flx alc cbent">
                    <img :src="$Localimg('tz.png')" alt="" @click="tomessage" />
                    <img :src="$Localimg('dc.png')" @click="daochu" alt="" style="margin-left: 20px;" />
                </div>
            </div>
            <div class="flx alc" style="box-sizing: border-box;padding: 0 30px 30px 30px;">
                <!-- <el-checkbox v-model="isAllCheck" :indeterminate="isIndeterminate" @change="handleCheckAllChange">全选</el-checkbox> -->
                <div class="passbtn" style="margin-left: 26px;" @click="passItems">通过</div>
                <div class="passbtn" style="background: #E4393C;" @click="refuseItems">拒绝</div>
            </div>
            <el-table ref="tableRef" :data="tableData" tooltip-effect="dark" style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column prop="name" label="姓名" width="80">
                </el-table-column>
                <el-table-column prop="company_name" label="企业名称" width="240" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="position_name" label="岗位职务" width="180" show-overflow-tooltip>
                </el-table-column>
                <!-- <el-table-column label="日期" width="120">
                    <template slot-scope="scope">{{ scope.row.createtime_text }}</template>
                </el-table-column> -->
                <el-table-column prop="tel2" label="手机" width="120" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="email" label="邮箱" width="180" show-overflow-tooltip>
                </el-table-column>

                <el-table-column prop="name" label="状态" width="120">
                    <template slot-scope="scope">
                        <div
                            :style="scope.row.check_status == 0?'' : scope.row.check_status == 1?'' : scope.row.check_status == 2?'color:#4CC864' : 'color:#E4393C'">
                            {{ scope.row.check_status == 0?'未审核' : scope.row.check_status == 1?'未审核' : scope.row.check_status == 2?'已通过' : '未通过'}}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column prop="spec_name" label="票种名称" width="180" show-overflow-tooltip>
                </el-table-column>

                <el-table-column prop="order_status_text" label="支付状态" width="100" show-overflow-tooltip>
                </el-table-column>

                <el-table-column prop="createtime_text" label="报名时间" width="100" show-overflow-tooltip>
                </el-table-column>
                <el-table-column fixed="right" label="详情">
                    <template slot-scope="scope">
                        <el-popover placement="right" width="400" trigger="hover">
                            <div class="userInfo">
                                <div class="userinfoTitle">
                                    信息详情
                                </div>
                                <div class="userDetails">
                                    <div class="basitem flx alc">
                                        <div class="baleft">
                                            姓名:
                                        </div>
                                        <div class="baright">
                                            {{scope.row.name}}
                                        </div>
                                    </div>
                                    <div class="basitem flx alc">
                                        <div class="baleft">
                                            手机号码:
                                        </div>
                                        <div class="baright">
                                            {{scope.row.tel}}
                                        </div>
                                    </div>
                                    <div class="basitem flx alc">
                                        <div class="baleft">
                                            电子邮箱:
                                        </div>
                                        <div class="baright">
                                            {{scope.row.email}}
                                        </div>
                                    </div>
                                    <div class="basitem flx alc">
                                        <div class="baleft">
                                            公司名称:
                                        </div>
                                        <div class="baright">
                                            {{scope.row.company_name}}
                                        </div>
                                    </div>
                                    <div class="basitem flx alc">
                                        <div class="baleft">
                                            职务:
                                        </div>
                                        <div class="baright">
                                            {{scope.row.position_name}}
                                        </div>
                                    </div>
                                    <div class="basitem flx alc">
                                        <div class="baleft">
                                            行业:
                                        </div>
                                        <div class="baright">
                                            {{scope.row.industry_name}}
                                        </div>
                                    </div>
                                    <div class="basitem flx alc">
                                        <div class="baleft">
                                            所在城市:
                                        </div>
                                        <div class="baright">
                                            {{scope.row.address}}
                                        </div>
                                    </div>
                                    <div class="basitem flx alc">
                                        <div class="baleft">
                                            身份验证:
                                        </div>
                                        <div class="baright" @click.stop="showBig(scope.row.id_img)" v-if="scope.row.id_img">
                                            <img :src="$img(scope.row.id_img)" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <img style="width: 26px;height: 26px;" slot="reference" :src="$Localimg('checkDetail.png')"
                                alt="" />
                        </el-popover>
                        <!-- <div class="flx alc">
                            <div class="bluebtn cursor" style="margin-left: 12px;" @click="checkPerson(scope.row)">
                                <img :src="$Localimg('ic5.png')" alt="" /><span>查看</span>
                            </div>

                            <div class="redbtn cursor"
                                v-if="scope.row.check_status == 1 || scope.row.check_status == 0 "
                                @click="refuseac(scope.row)" style="margin-left: 12px;">
                                <img :src="$Localimg('ic2.png')" alt="" /><span>拒绝</span>
                            </div>

                            <div class="greenbtn cursor"
                                v-if="scope.row.check_status == 1 || scope.row.check_status == 0 "
                                @click="passac(scope.row)" style="margin-left: 12px;">
                                <img :src="$Localimg('ic4.png')" alt="" /><span>通过</span>
                            </div>
                        </div> -->
                    </template>
                </el-table-column>
            </el-table>
            <div style="padding: 20px 0;">
                <el-pagination :page-size="20" :hide-on-single-page="true" background layout="prev, pager, next"
                    @current-change="handleCurrentChange" :total="totals">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="拒绝理由" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <!-- 多行文本框 -->
            <el-input v-model="textareaVal" type="textarea" :rows="6" placeholder="请输入拒绝理由" resize="none"
                maxlength="500" show-word-limit></el-input>
            <span>拒绝后，用户已支付的报名款项将原路退回</span>
            <!-- 底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false,textareaVal = ''">取消</el-button>
                <el-button type="primary" @click="submit">确定提交</el-button>
            </span>
        </el-dialog>
        <el-dialog title="拒绝理由" :visible.sync="dialogVisible1" width="30%" :before-close="handleClose1">
            <!-- 多行文本框 -->
            <el-input v-model="textareaVal1" type="textarea" :rows="6" placeholder="请输入拒绝理由" resize="none"
                maxlength="500" show-word-limit></el-input>
            <span class="pis">拒绝后，用户已支付的报名款项将原路退回</span>
            <!-- 底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible1 = false,textareaVal1 = ''">取消</el-button>
                <el-button type="primary" @click="submit1">确定提交</el-button>
            </span>
        </el-dialog>
        <div class="mask" v-if="show == true">
            <div class="maskContent">
                <div class="maskTitle">
                    提示
                </div>
                <div class="maskContents" v-text="word">
                </div>
                <div class="alertbtns flx alc jsb">
                    <div class="alertbtn" @click="show = false">
                        取消
                    </div>
                    <div class="alertbtn aconfri" @click="confirmThis">
                        确认
                    </div>
                </div>
            </div>
        </div>
		
		<div class="bigImge" v-if="bigs == true" @click="bigs = false">
			<img :src="$img(currentImg)" alt="">
		</div>
		
    </div>
</template>

<script>
    import {
        signpeople,
        shenAc
    } from "@/api/index.js"
    export default {
        data() {
            return {
				bigs:false,
				currentImg:'',
                show:false,
                checked: false,
                isAllCheck: false,
                isIndeterminate: false, // 半选状态
                gridData: [],
                selectedRows: [],
                totals: 0,
                id: "",
                page: 1,
                size: 20,
                activeName: "1",
                tableData: [],
                multipleSelection: [],
                num1: 0,
                num2: 0,
                num3: 0,
                dialogVisible: false,
                dialogVisible1: false,
                selid: {},
                textareaVal: "",
                selids: "",
                textareaVal1: "",
                values: "",
                options: [{
                        label: '全部',
                        value: '0'
                    }, {
                        label: '未审核',
                        value: '1'
                    },
                    {
                        label: '已通过',
                        value: '2'
                    },
                    {
                        label: '未通过',
                        value: '3'
                    }
                ],
                value: "0"
            }
        },
        created() {
            this.id = this.$route.query.id
            this.getList()
        },
        methods: {
			showBig(e){
				let that = this
				that.currentImg = e
				that.bigs = true
				console.log(e)
			},
            handleCheckAllChange(val) {
                this.selectedRows = []
                this.tableData.forEach(row => {
                    this.$refs.tableRef.toggleRowSelection(row, val)
                })
                this.isIndeterminate = false
            },
            searchThis() {
                let that = this
                that.page = 1
                that.getList()
            },
            checkSelectable(row) {
                // 示例：status=1 的行禁止勾选
                if (row.check_status == 1 || row.check_status == 0) {
                    return true
                }
                return false
            },
            daochu() {
                let that = this
                window.open(that.$baseUrl + '/api/Index/activity_channel_download_excel?source=activity&activity_id=' +
                    this.$route.query.id + '&keywords='+that.values + '&check_status='+that.value)
                that.$message({
                    type: 'success',
                    message: "导出成功"
                });
            },
            // 关闭弹窗回调
            handleClose() {
                this.dialogVisible = false
                this.textareaVal = '' // 关闭清空内容
            },
            handleClose1() {
                this.dialogVisible1 = false
                this.textareaVal1 = '' // 关闭清空内容
            },
            tomessage() {
                this.$router.push({
                    path: '/', // 写路由path
                    query: {
                        id: 0
                    }
                })
            },
            refuseItems() {
                let that = this
                console.log("refuse")
                let atr = []
                that.selectedRows.forEach((v, i) => {
                    atr.push(v.id)
                })
                if (atr.length == 0) {
                    that.$message({
                        type: 'warning',
                        message: "请至少选择1个用户"
                    });
                    return
                }
                that.selids = atr.join()
                that.dialogVisible1 = true
            },
            passItems() {
                let that = this
                let atr = []
                that.selectedRows.forEach((v, i) => {
                    atr.push(v.id)
                })
                if (atr.length == 0) {
                    that.$message({
                        type: 'warning',
                        message: "请至少选择1个用户"
                    });
                    return
                }
                let data = {}
                data.ids = atr.join()
                data.type = 2
                that.$confirm('确定要通过' + atr.length + '个用户的申请吗?', ' ', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    shenAc(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            submit() {
                let that = this
                let data = {}
                data.ids = that.selid.id
                data.type = 3
                data.check_remark = that.textareaVal
                shenAc(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.$message({
                            type: 'success',
                            message: res.msg
                        });
                        that.getList()
                        that.dialogVisible = false
                    } else {
                        that.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            },
            submit1() {
                let that = this
                let data = {}
                data.ids = that.selids
                data.type = 3
                data.check_remark = that.textareaVal1
                shenAc(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.$message({
                            type: 'success',
                            message: res.msg
                        });
                        that.getList()
                        that.dialogVisible1 = false
                    } else {
                        that.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            },
            refuseac(e) {
                let that = this
                that.selid = e
                that.dialogVisible = true
            },
            passac(e) {
                let that = this
                let data = {}
                data.ids = e.id
                data.type = 2
                that.$confirm('确定要通过该用户的申请吗?', ' ', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    shenAc(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            checkPerson(e) {
                console.log(e)
                this.$router.push({
                    path: '/AcInfo', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            },
            getList() {
                let that = this
                let data = {}
                data.check_status = that.value
                data.page = that.page
                data.size = that.size
                data.id = that.id
                data.source = 'check'
                data.keywords = that.values
                signpeople(data).then((res) => {
                    if (res.code == 1) {
                        that.totals = res.data.list.total
                        that.tableData = res.data.list.data
                        that.num1 = res.data.num1
                        that.num2 = res.data.num2
                        that.num3 = res.data.num3
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            },
            handleCurrentChange(e) {
                console.log(e)
				this.page = e
				this.getList()
            },
            bobk() {
                this.$router.go(-1)
            },
            handleClick(e) {
                console.log(this.activeName)
                this.page = 1
                this.getList()
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(rows) {
                this.selectedRows = rows
                console.log(this.selectedRows)
                // 选中行数>0 且不等于全部，开启半选
                this.isIndeterminate = rows.length > 0 && rows.length < this.tableData.length
                this.isAllCheck = rows.length === this.tableData.length
            }
        }
    }
</script>

<style scoped>
	.bigImge img{
		width: auto;
		height: 80vh;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%,-50%);
		display: block;
	}
	.bigImge{
		position: fixed;
		width: 100vw;
		height: 100vh;
		z-index:99997 !important;
		left: 0;
		top: 0;
		background-color: rgba(0, 0, 0, 0.7);
	}
    .pis{
        font-size: 14px;
        color: #FF0F23;
        margin-top: 15px;
        display: block;
    }
    .passbtn {
        width: 56px;
        height: 35px;
        background: #4CC864;
        border-radius: 4px;
        text-align: center;
        line-height: 35px;
        font-weight: 500;
        font-size: 12px;
        color: #FFFFFF;
        margin-right: 20px;
    }

    .userDetails {
        background: #fff;
        box-sizing: border-box;
        padding: 10px;
        text-align: left;
    }

    .baleft {
        font-size: 10px;
        color: #666666;
        margin-right: 4px;
    }

    .basitem {
        margin-bottom: 4px;
    }

    .baright {
        font-size: 10px;
        color: #999999;
    }
    
    .baright img{
        width: 106px;
        height: 52px;
    }

    .userInfo {
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #E8E8E8;
    }

    .userinfoTitle {
        width: 100%;
        height: 31px;
        background: #F9F9F9;
        line-height: 31px;
        text-align: left;
        box-sizing: border-box;
        padding-left: 9px;
    }

    .cbent img {
        width: 88px;
        height: 46px;
        cursor: pointer;
    }

    .checkBtn {
        width: 88px;
        height: 46px;
        background: #007AFF;
        border-radius: 6px;
        text-align: center;
        line-height: 46px;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        cursor: pointer;
    }

    .demo-input-suffix {
        display: flex;
        align-items: center;
        margin-right: 40px;
    }

    .deword {
        font-size: 14px;
        color: #48576A;
        flex-shrink: 0;
        margin-right: 20px;
    }

    .fs {
        width: 1460px;
        background-color: #fff;
        margin: 0 auto;
    }

    .bk {
        width: 1460px;
        height: 68px;
        background: #FFFFFF;
        box-sizing: border-box;
        padding: 0 30px;
        margin: 0 auto 20px;
        font-size: 14px;
        color: #000000;
    }
</style>